import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import withScopedTranslations from '../../../../withScopedTranslations/withScopedTranslations';

const InRealizationCell = ({ pickupDate, status, t, }) => {
  const isSentForTransportStatus = status === 'sent_for_transport';
  const isPickedUpStatus = status === 'picked_up';

  const cellContent = () => {
    if (pickupDate) {
      return <span>{moment(pickupDate).format('DD.MM.YYYY')}</span>;
    } else if (isSentForTransportStatus) {
      return <span>{t('sent_for_transport')}</span>;
    } else if (isPickedUpStatus) {
      // ask PM if we should set picked_up status
      return <span />;
    }
    return (
      <button className="btn transparent">
        <span>{t('set_date')}</span>
      </button>
    );
  };

  return cellContent();
};

InRealizationCell.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string,
  pickupDate: PropTypes.string,
};

InRealizationCell.defaultProps = {
  status: '',
  pickupDate: null,
};
export default withScopedTranslations('tables.in_realization_cell')(InRealizationCell);
